import React, { Fragment } from 'react'
import classNames from 'classnames'

const SelectField = ({ field }) => {
  const { input, className, placeholder, type, options, meta: { touched, error }, popover, style = null} = field
  return (
    <Fragment>
      <div className='d-flex align-items-center'>
        <select
          {...input}
          className={classNames(className, (touched && error) && 'has-error')}
          placeholder={placeholder}
          type={type}
          style={style ? style : {}}
        >
          {options}
        </select>
        {popover}
      </div>
      {(touched && error) &&
        <div>
          <small style={{ color: 'red' }} ><i className='fa fa-exclamation-triangle' /> {error}</small>
        </div>}
    </Fragment>
  )
}

export default SelectField
